

export function image19_click(event) {
	//Add your code for this event here: 
}